import {useMediaQuery} from '@mui/material'
import {forwardRef, ForwardRefRenderFunction, ReactNode, useMemo, useRef} from 'react'
import {useUser} from 'entities/user'
import {Sidebar} from 'features/sidebar'
import {UserStatus} from 'shared/types'
import {BottomMenu} from 'widgets/bottomMenu'
import {HeaderDesktop, HeaderMobile} from 'widgets/header' //todo
import {ChatRequests} from './chatRequests'
import {MyContacts} from './myContacts'
import styles from './styles.module.scss'

type LayoutProps = {
  children: ReactNode
  childrenTop?: ReactNode
  mobilePaddingTop?: number
}

const Layout: ForwardRefRenderFunction<HTMLDivElement, LayoutProps> = (
  {children, childrenTop, mobilePaddingTop},
  forwardRef
) => {
  const is1280p = useMediaQuery(`(max-width: ${styles.is1280p})`)
  const is768p = useMediaQuery(`(max-width: ${styles.is768p})`)
  const ref = useRef<HTMLDivElement | null>(null)
  const {status} = useUser()
  const isActive = useMemo(() => status === UserStatus.ACTIVE, [status])

  const setRef = (node: HTMLDivElement | null) => {
    ref.current = node

    if (typeof forwardRef === 'function') {
      forwardRef(node)
    } else if (forwardRef) {
      forwardRef.current = node
    }
  }

  return (
    <div className={styles.root}>
      {is768p ? <HeaderMobile wrapperRef={ref} mobilePaddingTop={mobilePaddingTop} /> : <HeaderDesktop />}
      {childrenTop}
      <div className={`${styles.customScroll} ${styles.scrollWrapper}`} ref={setRef} style={{paddingTop: is768p ? mobilePaddingTop : 0}}>
        <div className={styles.wrapper}>
          <div className={styles.workArea}>
            {children}
            {!is768p ? <Sidebar className={styles.sidebar} /> : null}
            {!is1280p && isActive ? <div className={styles.wrapperRightPanel}>
              <div className={styles.fixedPanel}>
                <MyContacts />
                <ChatRequests />
              </div>
            </div> : null}
          </div>
        </div>
      </div>
      {is768p ? <BottomMenu /> : null}
    </div>
  )
}

export const GlobalScrollLayout = forwardRef(Layout)